import { AdStatus } from '@/types';
import { AdKind, Shop } from '@/api/types/common.types';
import { PageInfo } from '@/api/types/pageInfo.types';
import { BookmarkedCategory } from '@/api/types/user.types';

export type BookmarkedAd = {
  id: string;
  photo: { url: string };
  path: string;
  region: string;
  title: string;
  price: number;
  shop: Shop | null;
  status: AdStatus;
  isBookmarked: boolean;
  kinds: AdKind[];
  updatedAt: string;
  legacyResourceId: number;
};

export type BookmarkNodes = {
  nodes: BookmarkedAd[];
  totalCount?: number;
};

export type BookmarkCollection = {
  id: string;
  name: string;
  isOwner: boolean;
  photos: { url: string }[];
  ads: { nodes: BookmarkedAd[]; totalCount: number; pageInfo: PageInfo };
};

export type BookmarkCollectionNodes = {
  nodes: BookmarkCollection[];
  pageInfo: PageInfo;
};

export interface GetUserDataQuery {
  currentUser: {
    id: string | null;
    bookmarks: BookmarkNodes;
    bookmarkedCategories: BookmarkedCategory[];
    bookmarkCollections: BookmarkCollectionNodes;
  };
}

export interface GetCollectionDataQuery {
  bookmarkCollectionDetails: BookmarkCollection;
}

export interface CreateCollectionQuery {
  createBookmarkCollection: {
    entity: {
      id: string;
      name: string;
    };
    errors: {
      code: string;
      path: string;
      message: string;
    }[];
  };
}

export interface UpdateCollectionQuery {
  updateBookmarkCollection: {
    entity: {
      id: string;
      name: string;
    };
    errors: {
      code: string;
      path: string;
      message: string;
    }[];
  };
}

export interface RemoveFromCollectionQuery {
  bookmarkCollectionIds: string[];
  adLegacyIds: string[];
}

export const OrderOptions = {
  CREATED_AT_ASC: 'CREATED_AT_ASC',
  CREATED_AT_DESC: 'CREATED_AT_DESC',
  PRICE_ASC: 'PRICE_ASC',
  PRICE_DESC: 'PRICE_DESC',
} as const;

export type OrderOption = (typeof OrderOptions)[keyof typeof OrderOptions];

export interface GetCollectionsListQuery {
  currentUser: {
    bookmarkCollections: {
      nodes: BookmarkCollection[];
      pageInfo: PageInfo;
      totalCount: number;
    };
  };
}
